import { App } from 'vue';
import CIcon from './CIcon.vue';
import { VueSvgIconPlugin } from '@yzfe/vue3-svgicon';
// import '@yzfe/svgicon/lib/svgicon.css';

export default function config(app: App): void {
    app.use(VueSvgIconPlugin, { tagName: 'vue-svgicon' });
    app.component(CIcon.name!, CIcon);
}
